export const messages = {
  en: {
    common: {
      logout: "Logout",
      yes: "yes",
      no: "no",
    },
    connect: {
      name: "InFormat",
      welcome: "Welcome to",
      login: "Login",
      password: "Password",
      connect: "Connect",
      slogan: "Be the next generation!",
      desc: "Your internal tool of training!",
      wait: "Connecting, please wait…",
      error: "Login and/or password incorrect, please try again…",
    },
    assignments: { 
      userName: "User name",
      title: "Title of the lesson",
      noLessonFound: "No lesson found!",
      dataWait: "Data loading, please wait…",
      skillName: "Skill: ",
      trainName: "Training: ",
      courseName: "Course: ",
      courseTrainer: "Trainer",
      labelFilter: "Lessons filter",
      labelErase: "Erase filter",
      labelLessonInitAll: "Initialize…",
      tipLessonInitAll: "Initialize all lessons…",
      modeFree: "Free mode",
      modeSeq: "Sequential mode",
      typeShow: "Show mode",
      typePerso: "Tablet mode", // Personal
      tipFoldUnfold: "Fold / unfold all levels",
      tipVisioShow: "View video conferencing room",
    },
    lesson: {
      name: "Lesson: ",
      skillName: "Skill: ",
      trainName: "Training: ",
      lang: "Lang: ",
      forUser: "Lessons for",
      btnTodo: "Start",
      btnResume: "Resume",
      btnDone: "Lesson done",
      btnRestart: "Start agin",
      btnWait: "Waiting",
      btnEval: "Evaluation",
      tipLessonInit: "Initialize this lesson…",
      tipCoachValidation: "Send a validation by the tutor…",
    },
    question: {
      goBack: "Return",
      goNext: "Next",
      goAnswer: "Answer",
      goUpload: "Upload files",
      seeDoc: "See or download the file",
      seeHtml: "Visit the website",
      btnSubmitTip: "Please watch the video", 
    },
    answer: {
      title: "Your answer",
      chooseFile: "File…",
      upload: "Upload",
      uploadInvit: "Please drop your files here",
      uploadFiles: "Choose files",
      uploadTypesDft: "File",
      uploadTypesList: "|images:Image|videos:Video|offices:Office|archives:Archive|audios:Audio|textes:Text|dbases:Database|",
      uploadRemove: "Remove this file from the selection",
      uploadRemoveAll: "Remove all selected files",
      uploadErrorFiles: "Maximum authorized quantity: ### files",
      uploadErrorFilesSize: "Maximum size allowed: ### MB per file",
      uploadErrorVideosSize: "Maximum size allowed: ### MB per video",
      uploadErrorExists: "Some choose files already exist in your selection",
      uploadTotalSize:'Total size',
      uploadProps:'KB|MB|.',
      audioBtnTooltip: "Start/stop reading the text…",
      openAmount: "Amount",
      openEurosSigle: "€",
      openEurosText: "Euros",
      openDollarsSigle: "$",
      openDollarsText: "Dollars",
      openHours: "Hours",
      openMinutes: "Minutes",
      openNow: "Now",
      openDay: "Day",
      openMonth: "Month",
      openYear: "Year",
      openToday: "Today",
      openError: "Fields marked in red have incorrect data, please correct them…",
      ok: "OK",
    },
    infos: {
      info: "Info",
      about: "About…",
      aboutTitle: "About",
      cgu: "CGU…",
      cguTitle: "CGU",
      help: "Help…",
      helpTitle: "Help",
      dico: "Dictionary…",
      dicoTitle: "Dictionary",
      sign: "Your signature…",
      signTitle: "Your Signature",
      signCanvas: "Please sign in the blue box below:",
      signImage: "You can erase and redo your signature if it does not suit you.",
      signChange: "You can change your signature if it does not suit you.",
    }, 
    modals: {
      info: "Info",
      close: "Close",
      validate: "Validate",
      cancel: "Cancel",
      save: "Save",
      approved: "Read and approved",
      signErase: "Clear Signature",
      signValid: "Validate Signature",
      signChange: "Change Signature",
    },
    evaluation: {
      modalEvalTitle: "Evaluation lesson", 
      modalEvalBody: "Please enter the password required to access this evaluation lesson",
      modalEvalLogin: "Login",
      modalEvalPass: "Password",
    },
    valid: {
      title: "Validation of learning",
      formTitle: "Evaluation Form",
      validate: "To validate",
      user: "Learner:",
      lesson: "Lesson:",
      coachValidation: "Validation of the evaluator:",
      coachPhone: "Evaluator's mobile phone:",
      coachPhonePlaceholder: "(numbers only)",
      coachComment: "Evaluator's comment:",
      requiredField: "All these fields are required",
      saveEvaluation: "Save this evaluation",
    },
    patience: {
      title: "All lessons",
      header: "Work in progress…",
      footer: "Please wait…",
      wait: "Data loading…", 
      init: "Initialization in progress…", 
    },
    learner: {
      civ: "Civility",
      civMr: "Mister",
      civMm: "Madam",
      first: "First Name",
      last: "Last Name", 
      birth: "Date of Birth",
      metier: "Job Metier", 
      phone: "Phone", 
      mobile: "Cell Phone", 
      email: "E-mail", 
      dd: "DD", 
      mm: "MM", 
      yyyy: "YYYY",
    },
  },
  de: {
    connect: {
      welcome: "Willkommen in",
      login: "Kemmung",
      password: "Passwort",
      connect: "Verbinden",
    },
  },
  fr: {
    common: {
      logout: "Se déconnecter",
      yes: "oui",
      no: "non",
    },
    connect: {
      name: "InFormat",
      welcome: "Bienvenue à",
      login: "Identifiant",
      password: "Mot de passe",
      connect: "Se connecter",
      slogan: "Be the next generation!",
      desc: "Votre outil interne de formation !",
      wait: "Connexion en cours, veuillez patienter…",
      error: "Identifiant et/ou mot de passe incorrects, veuillez réessayer…",
    },
    assignments: {
      userName: "Nom de l'utilisateur",
      title: "Titre de la leçon",
      noLessonFound: "Aucune leçon trouvée !",
      dataWait: "Données en cours de chargement, veuillez patienter…", 
      skillName: "Compétence : ",
      trainName: "Stage : ",
      courseName: "Cours : ",
      courseTrainer: "Formateur",
      labelFilter: "Filtre des leçons",
      labelErase: "Effacer le filtre",
      labelLessonInitAll: "Initialiser…",
      tipLessonInitAll: "Initialiser toutes les leçons…",
      modeFree: "Mode libre",
      modeSeq: "Mode séquentiel",
      typeShow: "Mode présentation",
      typePerso: "Mode tablette", // personnel
      tipFoldUnfold: "Plier / déplier tous les niveaux",
      tipVisioShow: "Afficher le salon de visioconférence",
    },
    lesson: {
      name: "Leçon : ",
      skillName: "Compétence : ",
      trainName: "Stage : ",
      lang: "Langue : ",
      forUser: "Leçons pour ",
      btnTodo: "Faire",
      btnResume: "Reprendre",
      btnDone: "Leçon faite",
      btnRestart: "Refaire",
      btnWait: "En attente",
      btnEval: "Évaluation",
      tipLessonInit: "Initialiser cette leçon…",
      tipCoachValidation: "Envoyer une validation par le tuteur…",
    },
    question: {
      goBack: "Retour",
      goNext: "Suivant",
      goAnswer: "Répondre",
      goUpload: "Téléverser des fichiers",
      seeDoc: "Voir ou télécharger le fichier",
      seeHtml: "Visiter le site internet",
      btnSubmitTip: "Veuillez visionner la vidéo",
    },
    answer: { 
      title: "Votre réponse",
      chooseFile: "Fichier…",
      upload: "Téléverser",
      uploadInvit: "Veuillez déposer vos fichiers ici",
      uploadFiles: "Choisir les fichiers",
      uploadTypesDft: "Fichier",
      uploadTypesList: "|images:Image|videos:Vidéo|offices:Office|archives:Archive|audios:Audio|textes:Texte|dbases:Database|",
      uploadRemove: "Enlever ce fichier de la sélection",
      uploadRemoveAll: "Enlever tous les fichier sélectionnés",
      uploadErrorFiles: "Quantité maximum autorisée : ### fichiers",
      uploadErrorFilesSize: "Taille maximum autorisée : ### Mo par fichier",
      uploadErrorVideosSize: "Taille maximum autorisée : ### Mo par vidéo",
      uploadErrorExists: "Certains fichiers choisis existent déjà dans votre sélection",
      uploadTotalSize:'Taille totale',
      uploadProps:'Ko|Mo|,',
      audioBtnTooltip: "Lancer/arrêter la lecture du texte…",
      openAmount: "Montant",
      openEurosSigle: "€",
      openEurosText: "Euros",
      openDollarsSigle: "$",
      openDollarsText: "Dollars",
      openHours: "Heures",
      openMinutes: "Minutes",
      openNow: "Maintenant",
      openDay: "Jour",
      openMonth: "Mois",
      openYear: "Année",
      openToday: "Aujourd'hui",
      openError: "Les champs signalés en rouge, ont des données incorrectes, veuillez les corriger Svp…",
      ok: "OK",
    },
    infos: {
      info: "Infos",
      about: "À propos…",
      aboutTitle: "À propos",
      cgu: "CGU…",
      cguTitle: "CGU",
      help: "Aide…",
      helpTitle: "Aide",
      dico: "Dictionnaire…",
      dicoTitle: "Dictionnaire",
      sign: "Votre Signature…",
      signTitle: "Votre Signature",
      signCanvas: "Veuillez signer dans le cadre bleu ci-dessous :",
      signImage: "Vous pouvez effacer et refaire votre signature si celle-ci ne vous convient pas.",
      signChange: "Vous pouvez changer votre signature si celle-ci ne vous convient pas.",
    },
    modals: {
      info: "Infos",
      close: "Fermer",
      validate: "Valider",
      cancel: "Annuler",
      save: "Enregistrer",
      approved: "Lu et Approuvé",
      signErase: "Effacer la Signature",
      signValid: "Valider la Signature",
      signChange: "Changer la Signature",
    },
    evaluation: {
      modalEvalTitle: "Leçon d'évaluation", 
      modalEvalBody: "Veuillez entrer le mot de passe requis pour accéder à cette leçon d'évaluation", 
      modalEvalLogin: "Identifiant",
      modalEvalPass: "Mot de passe",
    },
    valid: {
      title: "Validation des acquis",
      formTitle: "Formulaire d'évaluation",
      validate: "À valider",
      user: "Apprenant :",
      lesson: "Leçon :",
      coachValidation: "Validation de l'évaluateur :",
      coachPhone: "Téléphone mobile de l'évaluateur :",
      coachPhonePlaceholder: "(chiffres uniquement)",
      coachComment: "Commentaire de l'évaluateur :",
      requiredField: "Tous ces champs sont obligatoires",
      saveEvaluation: "Enregistrer cette évaluation",
    },
    patience: {
      title: "Toutes les leçons",
      header: "Traitement en cours…",
      footer: "Veuillez patienter…",
      wait: "Données en cours de chargement…", 
      init: "Initialisation en cours…", 
    },
    learner: {
      civ: "Civilité",
      civMr: "Monsieur",
      civMm: "Madame",
      first: "Prénom",
      last: "Nom", 
      birth: "Date de Naissance",
      metier: "Métier", 
      phone: "Téléphone", 
      mobile: "Mobile", 
      email: "Courriel", 
      dd: "JJ", 
      mm: "MM", 
      yyyy: "AAAA",
    },
  },
}




// WEBPACK FOOTER //
// ./src/locales/locales.js